import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import toast from "react-hot-toast";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [availableEvents, setAvailableEvents] = useState([]);
  const [showEventSelector, setShowEventSelector] = useState(false);
  const [userCredential, setUserCredential] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const email = e.target[0].value;
    const password = e.target[1].value;
    const eventCode = e.target[2].value;

    if (!email || !password || !eventCode) {
      toast.error("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      const userCred = await signInWithEmailAndPassword(auth, email, password);
      
      // Fetch user from Firestore and check eventCode
      const userDoc = await getDoc(doc(db, "users", userCred.user.uid));
      
      if (!userDoc.exists()) {
        await signOut(auth);
        toast.error("User data not found. Please contact support.");
        setLoading(false);
        return;
      }
      
      const userData = userDoc.data();
      const userEvents = userData.events || [userData.eventCode].filter(Boolean);
      
      if (!userEvents.includes(eventCode)) {
        await signOut(auth);
        
        if (userEvents.length > 0) {
          toast.error(`Invalid event code. You are registered for: ${userEvents.join(", ")}`);
        } else {
          toast.error("Invalid event code. Please check and try again.");
        }
        setLoading(false);
        return;
      }
      
      // Update current active event
      await updateDoc(doc(db, "users", userCred.user.uid), {
        currentEvent: eventCode
      });
      
      toast.success("Login successful!");
      navigate("/");
    } catch (err) {
      let errorMessage = "Login failed. Please try again.";
      
      switch (err.code) {
        case 'auth/user-not-found':
          errorMessage = "No account found with this email address.";
          break;
        case 'auth/wrong-password':
          errorMessage = "Incorrect password. Please try again.";
          break;
        case 'auth/invalid-email':
          errorMessage = "Invalid email address format.";
          break;
        case 'auth/user-disabled':
          errorMessage = "This account has been disabled.";
          break;
        case 'auth/too-many-requests':
          errorMessage = "Too many failed attempts. Please try again later.";
          break;
        default:
          console.error("Login error:", err);
      }
      
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="formContainer">
      <div className="formWrapper">
        <span className="logo">Planyt Chat</span>
        <span className="title">Login</span>
        <form onSubmit={handleSubmit}>
          <input type="email" placeholder="email" required />
          <input type="password" placeholder="password" required />
          <input type="text" placeholder="Event Code" required />
          <button disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <p>You don't have an account? <Link to="/register">Register</Link></p>
      </div>
    </div>
  );
};

export default Login;
